export default "__VITE_ASSET__BdH7hQCd__"